import classNames from 'classnames'
import { useRouter } from 'next/router'
import { loggedOutNavLinks } from '../header/utils/navigation-items'
import Link from '../Link'
import { DOMAIN } from '@/root/constants'
import { useAnalyticsEvent } from '@/hooks/analytics/use-analytics-event'
import { EN_HEADER_LINKS } from '@/root/utils/common/web/gtm-events/eventsList'

const DesktopStocksNavigationV2 = ({ host }: { host?: string }) => {
  const pushEvent = useAnalyticsEvent()
  const router = useRouter()
  const { pathname } = router

  return (
    <ul className="m-0 flex items-center space-x-1">
      {loggedOutNavLinks.map(
        ({ link, text, dontShowOn, showOnlyOn, navlinks }, index) => {
          const hostMatchingObjectToNotShow = dontShowOn?.find(
            el => el.host === host,
          )
          const navLink = navlinks?.filter(el => el.host === host)

          const hostMatchingObjectToOnlyShow = showOnlyOn?.find(
            el => el.host === host,
          )
          if (hostMatchingObjectToNotShow?.host === host) {
            return null
          }

          if (showOnlyOn && !(hostMatchingObjectToOnlyShow?.host === host)) {
            return null
          }

          const newLink = navLink?.[0]?.pathnameExact ?? link
          const urlObj = new URL(`${DOMAIN}${newLink}`)
          return (
            <li key={index} className="relative">
              <Link
                onClick={() =>
                  pushEvent({
                    gtmPayload: {
                      eventName: EN_HEADER_LINKS,
                      headerClickText: text,
                      source: pathname,
                      lob: newLink,
                    },
                  })
                }
                key={text}
                href={newLink}
                className={classNames(
                  'text-brand-grey-dark rounded-xl px-3 py-2',
                  {
                    'hover:text-brand-blue-azureRadiance ':
                      pathname !== urlObj.pathname,
                    '!text-brand-blue-azureRadiance font-medium':
                      pathname === urlObj.pathname,
                  },
                )}
                title={text}
              >
                {text}
              </Link>
            </li>
          )
        },
      )}
    </ul>
  )
}

export default DesktopStocksNavigationV2
